export default __webpack_public_path__ + "static/media/esg-dataset-logo-bw.a402272e.png";